import React, { useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import testimonials from '../../data/Testimonials/testimonials.json';

// Testimonial videos come from data/Testimonials/testimonials.json.
// A non-empty "caption" renders under the video (e.g. "Dorothy & Jim, 4-bed home, Seattle → Phoenix").
const GalleryContent = ({ classes }) => {
    // State to track whether each video is playing
    const [playing, setPlaying] = useState({});

    // Function to handle play on click
    const handlePlay = (key) => {
        setPlaying((prev) => ({ ...prev, [key]: true }));
    };

    return (
        <section className={`work-section ${classes}`} id="work">
            <div className="container">
                <div className="projects-list">
                    {testimonials.map((testimonial) => (
                        <div className="col-md-4 col-sm-12" key={testimonial.id}>
                            <div className="single-project-item">
                                <ReactPlayer
                                    url={testimonial.url}
                                    width="100%"
                                    height="280px"
                                    controls
                                    playing={playing[testimonial.id]}
                                    light={true} // Show thumbnail until clicked
                                    onClick={() => handlePlay(testimonial.id)} // Trigger play on first click
                                />
                                {testimonial.caption && (
                                    <p className="testimonial-caption">{testimonial.caption}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GalleryContent;
